<!-- <div *ngIf="heading !== undefined">{{heading}}</div> -->
<ng-container [ngSwitch]="headerSize">
    <h1 *ngSwitchCase="'h1'">{{heading}}</h1>
    <h2 *ngSwitchCase="'h2'">{{heading}}</h2>
    <h3 *ngSwitchCase="'h3'">{{heading}}</h3>
    <h4 *ngSwitchCase="'h4'">{{heading}}</h4>
    <h5 *ngSwitchCase="'h5'" [innerHtml]="heading"></h5>
    <h6 *ngSwitchCase="'h6'">{{heading}}</h6>
</ng-container>
<!-- <h3 *ngIf="heading">{{heading}}</h3> -->
<!-- <p *ngIf="isSinglePara ; else elseBlock" [innerHTML]="parasString1">{{[parasString1]}}</p> -->
<p *ngIf="paraLink!==undefined ; else elseBlock">
    <ng-container *ngFor="let line of toLines(para); let i = index;">
        <ng-container *ngIf="hasLink(i); else normalLine">
            <a [href]="getLink(i)" target="_blank" rel="noopener noreferrer">
                <ng-container *ngFor="let seg of segments(line)">
                    <strong *ngIf="seg.bold; else normalInLink">{{seg.text}}</strong>
                    <ng-template #normalInLink>{{seg.text}}</ng-template>
                </ng-container>
            </a>

            <br *ngIf="isSinglePara!==true">

        </ng-container>
        <ng-template #normalLine>
            <span [innerHTML]="processText(line)"></span>

        </ng-template>
    </ng-container>
</p>

<ng-template #elseBlock>
    <div *ngIf="isSinglePara && isSinglePara!==undefined; else elsePara">
        <p [innerHTML]="processText(parasString1)"></p>
    </div>

    <ng-template #elsePara>
        <p>
            <span *ngFor="let para1 of paras1" [innerHTML]="processText(para1)"></span>
        </p>
    </ng-template>

</ng-template>